export default class PermissionDeniedError extends Error {}
